module.exports = __webpack_public_path__ + "img/3.29cfc6b.jpg";